import update from 'immutability-helper';

import { ApplicationActionType } from './application.actions.types';
import * as actionTypes from './application.actions.types';
import { initialState } from './application.provider';
import { ApplicationContext, UserInfo } from './application.types';

const setAuthDataHelper = (state: ApplicationContext, token: string, userInfo: UserInfo) => {
  localStorage.setItem('token', token);
  localStorage.setItem('userInfo', JSON.stringify(userInfo));

  return update(state, {
    auth: {
      $merge: {
        isFetching: false,
        isLogged: true,
        token,
      },
    },
    userInfo: {
      $merge: userInfo,
    },
  });
};

export const applicationReducer = (state: ApplicationContext, action: ApplicationActionType) => {
  switch (action.type) {
    case actionTypes.INITIALIZE_AUTH: {
      let userInfo = null;
      let providerInfo = null;

      const token = localStorage.getItem('token');
      const userInfoString = localStorage.getItem('userInfo');
      const providersString = localStorage.getItem('providerInfo');

      if (userInfoString) {
        try {
          userInfo = JSON.parse(userInfoString);
        } catch (error) {
          localStorage.removeItem('userInfo');
        }
      }

      if (providersString) {
        try {
          providerInfo = JSON.parse(providersString);
        } catch (error) {
          localStorage.removeItem('providerInfo');
        }
      }

      return update(state, {
        auth: {
          $merge: {
            isLogged: !!token,
            token: token || '',
          },
        },
        providerInfo: {
          $merge: providerInfo || {
            fantasyName: null,
            hasAdminContact: false,
            id: null,
            name: null,
            rut: null,
          },
        },
        userInfo: {
          $merge: userInfo || {
            email: null,
            id: null,
            name: null,
            password: null,
            phone: null,
            rut: null,
          },
        },
      });
    }

    case actionTypes.LOGOUT: {
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('providerInfo');

      return update(state, {
        $merge: {
          ...initialState,
        },
      });
    }

    case actionTypes.SET_AUTH_DATA: {
      const { token, userInfo } = action.payload;
      return setAuthDataHelper(state, token, userInfo);
    }

    case actionTypes.SET_AUTH_LOADING: {
      const { isLoading } = action.payload;
      return update(state, {
        auth: { $merge: { isFetching: isLoading } },
      });
    }

    case actionTypes.SET_PROVIDER_INFO: {
      const providerInfo = action.payload;
      localStorage.setItem('providerInfo', JSON.stringify(providerInfo));

      return update(state, {
        providerInfo: { $merge: providerInfo },
      });
    }

    case actionTypes.SET_PROVIDERS: {
      const { providers } = action.payload;
      return update(state, {
        providers: { $set: providers },
      });
    }

    case actionTypes.SET_RECOVER_ACCOUNT: {
      const recoverAccount = action.payload;

      return update(state, {
        recoverAccount: { $merge: recoverAccount },
      });
    }

    case actionTypes.SET_RECOVER_ACCOUNT_INITIAL_STATE: {
      return update(state, {
        recoverAccount: { $merge: initialState.recoverAccount },
      });
    }

    default: {
      return state;
    }
  }
};
